import { render, staticRenderFns } from "./GreenDetail.vue?vue&type=template&id=4cf6889d&scoped=true&"
import script from "./GreenDetail.vue?vue&type=script&lang=js&"
export * from "./GreenDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf6889d",
  null
  
)

export default component.exports